export default __webpack_public_path__ + "static/media/woman.0afb2ae1.png";